import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/stranded',
        name: 'stranded',
        component: LayoutNoFooter,
        children: [
            {
                path: 'index',
                name: 'strandedIndex',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/stranded/index'),
                meta: {
                    title: '学生留堂管理',
                    isAuth: true,
                }
            },
            {
                path: 'setting',
                name: 'strandedSetting',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/stranded/setting'),
                meta: {
                    title: '学生留堂设置',
                    isAuth: true,
                }
            },
        ]
    },
]
